import React from "react";
import ShowPostContainer from "../templates/show-post/ShowPostContainer";
import withParams from "../modules/router-manage/withParams";

const ShowPostPage = ({ params }) => <ShowPostContainer params={params}/>;

export default withParams(ShowPostPage)



// WEBPACK FOOTER //
// ./src/pages/ShowPostPage.js